<template>
  <div class="km-participant-details align-items-center">
    <div class="paticipant-name-area">
      <div :class="currentUser" class="km-participant-name"> {{ participant.name }} </div>
      <span v-if="isEditable" class="ml-2 text-size-14">
        <font-awesome-icon :icon="['fas', 'pencil']" />
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MobileParticipantName',
  props: ['participant', 'isEditable', 'isEmailVisible', 'isCurrentUser'],
  data() {
    return {};
  },

  computed: {
    // participantEmail() {
    //   if( this.participant.user ) {
    //     return this.participant.user.email;
    //   }
    //   return this.participant.email;
    // },

    currentUser() {
    if( this.isCurrentUser) return "text-weight-bold";
    return null;
    }
  },

  methods: {},
};
</script>

<style scoped lang="scss">


.km-participant-details {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background-color: transparent;
  outline: 0px solid rgb(109, 191, 206);
  outline-offset: -1px;
  cursor: pointer;
  padding: 10px;
  height: 65px;
}


.km-participant {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.km-participant-email {
  width: 100%;
  text-align: center;

}

.paticipant-name-area {
  display: flex;
  justify-content: center;
  width: 100%;
}

.km-participant-name {
  white-space: nowrap;
  max-width: 250px;
  width: 100%;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  flex-basis: fit-content;
}


</style>
